import React, { useState, useEffect } from 'react';
import './PaymentModal.css';
import SalesAgreement from './SalesAgreement';

interface PaymentModalProps {
  isOpen: boolean;
  onClose: () => void;
  iframeUrl: string;
  bookingId: string | number;
  skipAgreement?: boolean;
}

const PaymentModal: React.FC<PaymentModalProps> = ({ isOpen, onClose, iframeUrl, bookingId, skipAgreement = false }) => {
  const [agreementAccepted, setAgreementAccepted] = useState(skipAgreement);
  const [showPayment, setShowPayment] = useState(skipAgreement);

  // skipAgreement değiştiğinde state'leri güncelle
  useEffect(() => {
    setAgreementAccepted(skipAgreement);
    setShowPayment(skipAgreement);
  }, [skipAgreement]);

  // Sayfa kapatılırsa / yeniden yüklenirse cancel-pending gönder (beacon - fire-and-forget)
  useEffect(() => {
    if (!isOpen || !bookingId) return;

    const handleBeforeUnload = () => {
      const url = `/api/bookings/${bookingId}/cancel-pending`;
      // sendBeacon tarayıcı kapansa bile isteği göndereceğini garanti eder
      if (navigator.sendBeacon) {
        navigator.sendBeacon(url, JSON.stringify({ reason: 'page_closed' }));
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [isOpen, bookingId]);

  if (!isOpen) return null;

  const handleProceedToPayment = () => {
    if (!agreementAccepted) {
      alert('Lütfen satış sözleşmesini okuyup onaylayın.');
      return;
    }
    setShowPayment(true);
  };

  const handleClose = () => {
    setAgreementAccepted(skipAgreement);
    setShowPayment(skipAgreement);
    onClose();
  };

  return (
    <div className="payment-modal-overlay" onClick={handleClose}>
      <div className="payment-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="payment-modal-header">
          <h2>{showPayment ? '💳 Güvenli Ödeme' : '📄 Satış Sözleşmesi'}</h2>
          <button className="close-button" onClick={handleClose}>✕</button>
        </div>
        
        <div className="payment-modal-body">
          {!showPayment ? (
            <>
              <div className="payment-info">
                <p>Ödemeye geçmeden önce lütfen satış sözleşmesini okuyup onaylayın.</p>
                <small>Rezervasyon No: {bookingId}</small>
              </div>
              
              <SalesAgreement
                isChecked={agreementAccepted}
                onCheckChange={setAgreementAccepted}
              />
              
              <button 
                className={`btn-proceed-payment ${!agreementAccepted ? 'disabled' : ''}`}
                onClick={handleProceedToPayment}
                disabled={!agreementAccepted}
              >
                ✓ Ödemeye Geç
              </button>
            </>
          ) : (
            <>
              <div className="payment-info">
                <p>🔒 PayTR güvenli ödeme sayfasına yönlendiriliyorsunuz</p>
                <small>Rezervasyon No: {bookingId}</small>
              </div>
              
              <iframe
                src={iframeUrl}
                id="paytriframe"
                frameBorder="0"
                scrolling="yes"
                allow="payment *; camera *; microphone *"
                allowFullScreen
                style={{ width: '100%', height: '600px', display: 'block' }}
                title="PayTR Payment"
              />
            </>
          )}
        </div>
        
        {showPayment && (
          <div className="payment-modal-footer">
            <p className="security-note">
              🛡️ Ödeme bilgileriniz PayTR güvencesi altındadır. 
              Kart bilgileriniz tarafımızla paylaşılmaz.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentModal;
